(function () {
  'use strict';

  var root = document.documentElement;
  root.classList.add('lb404-ready');

  function revealSections(scope) {
    var elements = (scope || document).querySelectorAll('.lb404-reveal:not([data-lb404-reveal-bound])');

    if (!elements.length) return;

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      elements.forEach(function (element) {
        element.classList.add('lb404-inview');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('lb404-inview');
        observer.unobserve(entry.target);
      });
    }, {
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.08
    });

    elements.forEach(function (element) {
      element.setAttribute('data-lb404-reveal-bound', 'true');
      observer.observe(element);
    });
  }

  function enhanceEmptyCart(scope) {
    var emptyCart = (scope || document).querySelector('.drawer__cart-empty .drawer__scrollable');
    if (!emptyCart || emptyCart.hasAttribute('data-lb404-enhanced')) return;

    var rootRoute = window.theme && window.theme.routes ? window.theme.routes.home : '/';
    var collectionUrl = rootRoute.replace(/\/?$/, '/') + 'collections/alle-produkte';

    emptyCart.setAttribute('data-lb404-enhanced', 'true');
    emptyCart.innerHTML =
      '<p class="lb404-kicker">ERROR_404 / EMPTY BAG</p>' +
      '<h3 class="h1">YOUR BAG<br>GOT LOST.</h3>' +
      '<p>404, obviously. Zeit, den aktuellen Drop zu finden.</p>' +
      '<a class="btn" href="' + collectionUrl + '">CURRENT DROP ENTDECKEN</a>';
  }

  function syncProductThumbA11y(scope) {
    var galleries = (scope || document).querySelectorAll('[data-product-thumbs]:not([data-lb404-a11y-bound])');

    galleries.forEach(function (gallery) {
      function sync() {
        gallery.querySelectorAll('[data-product-thumb]').forEach(function (thumb) {
          if (thumb.classList.contains('is-active')) {
            thumb.setAttribute('aria-current', 'true');
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
      }

      gallery.setAttribute('data-lb404-a11y-bound', 'true');
      sync();

      var observer = new MutationObserver(sync);
      observer.observe(gallery, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
    });
  }

  function init(scope) {
    revealSections(scope);
    enhanceEmptyCart(scope);
    syncProductThumbA11y(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('ajaxProduct:added', function () {
    var drawer = document.getElementById('CartDrawer');
    if (drawer) drawer.setAttribute('data-lb404-has-items', 'true');
  });
})();
